<template>
  <div class="row items-center">
    <div style="width: 8em; text-align: right;" v-if="labelTypeComputed === 'left'">{{labelComputed}}:</div>
    <div class="col-auto q-pl-md" v-if="typeComputed === 'popup' && !$apollo.loading">
      {{value}}
      <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"/>
      <m-popup-edit v-model="value"
                    @save="v => updateComputed(v, update)" :buttons="false"/>
    </div>
    <div class="col-auto q-pl-md" v-if="typeComputed === 'datetime' && !$apollo.loading">
      <span @click="$refs.paidPicker.show()">
        {{formatDateTime(value) || `Not ${labelComputed}`}}
        <m-date-time-picker ref="paidPicker" :value="value" @input="v => updateComputed(v, update)"/>
        <q-btn v-if="value" size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
      </span>
      <q-btn v-if="!value" size="sm" color="primary" flat dense class="q-ml-sm q-py-none" @click="updateComputed(new Date(), update)" icon="check" label="Done"/>
<!--      <q-btn v-if="!value" size="sm" flat dense class="q-ml-sm q-py-none" @click="updateComputed(new Date(), update)" icon="check"/>-->
      <q-btn v-if="value" size="xs" flat dense icon="delete" class="q-ml-sm" color="red" @click="updateComputed(null, update)"></q-btn>
    </div>
    <div class="col-auto q-pl-md" v-if="typeComputed === 'checkbox' && !$apollo.loading">
      <q-checkbox :value="!!value" @input="v => updateComputed(v, update)" />
    </div>
    <div class="col-auto q-pl-md" v-if="typeComputed === 'enum' && !$apollo.loading">
      <q-select :value="value" @input="v => updateComputed(v, update)" :options="enums"/>
    </div>
    <div class="col q-pl-md" v-else-if="typeComputed === 'input' && !$apollo.loading">
      <q-input :label="labelTypeComputed === 'input' ? labelComputed : undefined" :filled="filled" :autogrow="autogrow" :value="value" @input="v => updateComputed(v, update)" debounce="1000" :type="inputType || null" />
    </div>
    <div class="col q-pl-md" v-else-if="typeComputed === 'json' && !$apollo.loading">
      <q-input dense :value="JSON.stringify(value, null, 2)" @input="v => updateComputed(JSON.parse(v), update)" debounce="1000" type="textarea" />
    </div>
    <div class="col q-pl-md" v-else-if="typeComputed === 'list' && !$apollo.loading">
      <q-table
        :data="tableData"
        :columns="columns"
        dense
        hide-bottom
        hide-header
        separator="cell"
        :loading="$apollo.loading"
        :pagination="{rowsPerPage: 0}"
        row-key="name" >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="key" :props="props">
              {{ props.row.key }}
              <m-popup-edit v-model="props.row.key" select-on-focus
                            @save="v => updatePart({[props.row.key]: undefined, [v]: props.row.value})" :buttons="false"/>
            </q-td>
            <q-td key="value" :props="props">
              {{ props.row.value }}
              <m-popup-edit :value="valToStr(props.row.value)" select-on-focus
                            @save="v => updatePart({ [props.row.key]: v })" :buttons="false"/>
            </q-td>
            <q-td key="action" :props="props">
              <q-btn dense flat icon="delete" class="full-width" @click="deleteTableItem(props.row.key)" />
            </q-td>
          </q-tr>
        </template>
        <template v-slot:bottom-row>
          <q-tr>
            <q-td colspan="100%">
              <q-btn dense flat icon="add" class="full-width" @click="tableAdd" size="xs" />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="col q-pl-md" v-else-if="typeComputed === 'array' && !$apollo.loading">
      <q-table
        :data="arrayData"
        :columns="arrayColumns"
        dense
        hide-bottom
        hide-header
        :loading="$apollo.loading"
        :pagination="{rowsPerPage: 0}"
        row-key="name" >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="value" :props="props">
              {{ props.row.value }}
              <m-popup-edit :value="valToStr(props.row.value)"
                            @save="v => updateArrayPart(props.row.index, v)" :buttons="false"/>
            </q-td>
            <q-td key="action" :props="props">
              <q-btn dense flat icon="delete" class="full-width" @click="deleteArrayItem(props.row.index)" />
            </q-td>
          </q-tr>
        </template>
        <template v-slot:bottom-row>
          <q-tr>
            <q-td colspan="100%">
              <q-btn dense flat icon="add" class="full-width" @click="arrayAdd" size="xs" />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import MPopupEdit from '../MPopupEdit'
import gql from 'graphql-tag'
import MDateTimePicker from '../MDateTimePicker'
import { formatDateTime, lowerCaseFirstLetter, properCase, unCamelCase } from '../../../util/string'
import adminNotifyError from '../../../util/adminNotifyError'

export default {
  name: 'MEditItem',
  apollo: {
    item () {
      return {
        query: this.cacheQuery,
        variables: () => ({ id: this.id }),
        update (result) {
          return result[lowerCaseFirstLetter(this.graphqlType)]
        }
      }
    }
    // enumsGql () {
    //   return {
    //     // Name of the type should be like: EmailTemplateEventEnum
    //     // Where prop graphqlType = EmailTemplate
    //     //       prop       field = event
    //     // ie the value is in emailTemplate(id).event
    //     query: gql`query {
    //         __type (name: "${this.graphqlType}${properCase(this.field)}Enum") {
    //         name
    //         enumValues {
    //           name
    //         }
    //       }
    //     }`,
    //     update (result) {
    //       return result.__type.enumValues.map(v => v.name)
    //     },
    //     skip () {
    //       return this.type !== 'enum'
    //     }
    //   }
    // }
  },
  components: { MDateTimePicker, MPopupEdit },
  props: ['field', 'label', 'labelType', 'updateFunction', 'type', 'graphqlType', 'id', 'inputType', 'filled', 'autogrow', 'enums'],
  computed: {
    currentUUID () {
      return this.$store.state.auth.currentUUID
    },
    value () {
      if (this.type === 'list') {
        return this.item[this.field] || {}
      }
      return this.item[this.field]
    },
    tableData () {
      const data = this.value
      return Object.keys(data).map(key => { return { key, value: data[key] } })
    },
    columns () {
      return [
        { name: 'key', required: true, label: 'Name', align: 'left', field: row => row.key, sortable: false },
        { name: 'value', required: true, label: 'Value', align: 'left', field: row => row.value, sortable: false },
        { name: 'action', align: 'left', sortable: false }
      ]
    },
    arrayData () {
      return this.value.map((value, index) => { return { value, index } })
    },
    arrayColumns () {
      return [
        { name: 'value', required: true, label: 'Value', align: 'left', field: row => row.value, sortable: false },
        { name: 'action', align: 'left', sortable: false }
      ]
    },
    labelComputed () {
      return this.label || properCase(unCamelCase(this.field))
    },
    labelTypeComputed () {
      return this.labelType || 'left'
    },
    typeComputed () {
      return this.type || 'popup'
    },
    updateComputed () {
      // the prop accepts two inputs: newVal - the new value and update which is just the this.update function.
      // that means that this.update get's passed itself as it's second input, but that's fine we just ignore it.
      // It's important so the user can perform an update from the updateFunction prop function.
      return this.updateFunction || this.update
    },
    mutationType () {
      return 'edit' + this.graphqlType
    },
    graphQlInputType () {
      return this.graphqlType + 'Input!'
    },
    editMutation () {
      return gql`mutation ${this.mutationType} ($id: ID!, $input: ${this.graphQlInputType}) {
          ${this.mutationType}(id: $id, input: $input) {
            id,
            ${this.field}
          }
        }
      `
    },
    cacheQuery () {
      return gql`query ${lowerCaseFirstLetter(this.graphqlType)} ($id: ID!) {
        ${lowerCaseFirstLetter(this.graphqlType)} (id: $id) {
            id
            ${this.field}
        }
      }
      `
    }
  },
  methods: {
    formatDateTime: formatDateTime,
    deleteTableItem (key) {
      this.$q.dialog({
        title: 'Delete Order',
        message: `Are you sure you want to delete ${key} from ${this.labelComputed.toLowerCase()}?`,
        cancel: true
      }).onOk(() => {
        this.updatePart({ [key]: undefined })
      })
    },
    deleteArrayItem (index) {
      this.$q.dialog({
        title: 'Delete Order',
        message: `Are you sure you want to delete '${this.value[index]}' from ${this.labelComputed.toLowerCase()}?`,
        cancel: true
      }).onOk(async () => {
        if (index < 0) return
        let updatedValue = Object.assign([], this.value)
        updatedValue.splice(index, 1)
        await this.updateComputed(updatedValue, this.update)
      })
    },
    tableAdd () {
      this.$q.dialog({
        title: 'Name',
        cancel: true,
        prompt: {
          model: '',
          type: 'text'
        }
      }).onOk((name) => {
        this.$q.dialog({
          title: 'Value',
          cancel: true,
          prompt: {
            model: '',
            type: 'text'
          }
        }).onOk((value) => {
          this.updatePart({ [name]: value })
        })
      })
    },
    arrayAdd () {
      this.$q.dialog({
        title: 'Name',
        cancel: true,
        prompt: {
          model: '',
          type: 'text'
        }
      }).onOk(async (value) => {
        // Rebuild the whole field
        let updatedValue = Object.assign([], this.value)
        updatedValue.push(value)
        await this.updateComputed(updatedValue)
      })
    },
    /**
     * @param input pass in the part of the field that should be updated. eg. { brand: '360' }
     * @returns {Promise<void>}
     */
    async updatePart (input) {
      // Rebuild the whole field
      let updatedValue = Object.assign({}, this.value)
      Object.assign(updatedValue, input)
      await this.updateComputed(updatedValue, this.update)
    },
    async updateArrayPart (i, val) {
      // Rebuild the whole field
      let updatedValue = Object.assign([], this.value)
      updatedValue[i] = val
      await this.updateComputed(updatedValue, this.update)
    },
    valToStr (val) {
      if (typeof val === 'object') {
        return JSON.stringify(val)
      }
      return val
    },
    async update (updatedValue, unusedUpdateFunc) {
      if (this.inputType === 'number') updatedValue = Number(updatedValue)
      const input = { [this.field]: updatedValue }
      try {
        await this.$apollo.mutate({
          mutation: this.editMutation,
          variables: {
            id: this.id,
            input
          },
          context: {
            headers: {
              uuid: this.currentUUID
            }
          },
          update: (cache, resp) => {
            // const storeData = cache.readQuery({ query: this.cacheQuery, variables: { id: this.id } })
            // storeData[this.graphqlType.toLowerCase()][this.field] = resp.data[this.mutationType][this.field]
            // cache.writeQuery({
            //   query: this.cacheQuery,
            //   data: storeData,
            //   variables: { id: this.id }
            // })
            return resp.data[this.mutationType]
          },
          optimisticResponse: {
            __typename: 'Mutation',
            [this.mutationType]: {
              __typename: this.graphqlType,
              id: this.id,
              ...input
            }
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Error updating', error)
      }
    }
  },
  data () {
    return {
      pagination: {}
    }
  }
}
</script>

<style scoped>

</style>
